import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function About() {
  return (
    <>
      <SEOHead
        title="关于我们 - 韩漫网址 - 韩国漫画无删减下拉式阅读平台"
        description="韩漫网址致力于为中文读者提供最优质的韩国漫画阅读体验。了解我们的品牌故事、用户口碑，以及如何联系我们获取更多帮助。"
        keywords="韩漫网址,关于我们,韩国漫画平台,免费韩漫,联系我们"
        canonicalUrl="https://hanman.example.com/about"
      />
      <SchemaOrg type="AboutPage" data={{
        name: '关于韩漫网址',
        description: '韩漫网址致力于为中文读者提供最优质的韩国漫画阅读体验。',
        url: 'https://hanman.example.com/about',
      }} />
      <SchemaOrg type="FAQPage" data={{
        mainEntity: [
          { '@type': 'Question', name: '韩漫网址是什么？', acceptedAnswer: { '@type': 'Answer', text: '韩漫网址是一个专注于韩国漫画在线阅读的中文平台，提供无删减、下拉式阅读体验的免费韩漫资源，覆盖恋爱、奇幻、动作、悬疑、喜剧、剧情等多样化题材。' } },
          { '@type': 'Question', name: '韩漫网址上的漫画真的是免费的吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，韩漫网址上所有韩国漫画资源均免费提供在线阅读，无需任何付费即可畅快浏览全部内容。' } },
          { '@type': 'Question', name: '韩漫网址支持哪些题材？', acceptedAnswer: { '@type': 'Answer', text: '我们目前涵盖恋爱、奇幻、动作、悬疑、喜剧、剧情六大热门题材，持续扩充新的分类和漫画资源。' } },
        ],
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <div className="bg-background-100 border-b border-background-200/70">
            <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
              <Breadcrumb items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]} />
              <h1 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                关于我们
              </h1>
              <p className="mt-2 text-sm text-foreground-600">
                了解韩漫网址的品牌故事与发展愿景
              </p>
            </div>
          </div>

          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                    品牌故事
                  </h2>
                  <div className="w-12 h-1 bg-primary-500 rounded-full mt-3 mb-5"></div>
                  <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
                    <p>
                      韩漫网址诞生于一群热爱韩国漫画的中文读者的共同愿景。我们深知，在中国有大量喜爱韩国漫画的读者，却往往因为语言障碍、付费壁垒或不完整的翻译而无法享受到原汁原味的韩漫作品。
                    </p>
                    <p>
                      2024年，我们决定打造一个真正为中文读者服务的韩国漫画在线阅读平台。我们坚持<strong>无删减</strong>原则，完整呈现原作内容；我们采用<strong>下拉式阅读</strong>方式，让读者沉浸在流畅的漫画世界中；我们承诺<strong>完全免费</strong>，让每一位读者都能无障碍地享受优质韩漫。
                    </p>
                    <p>
                      从最初的十几部作品起步，如今的韩漫网址已经成为拥有海量韩国漫画资源、覆盖六大热门题材的综合阅读平台。我们与多位优秀的翻译团队合作，确保每一部作品都能以高质量的中文呈现给读者。
                    </p>
                    <p>
                      未来，我们将继续扩充漫画资源库，优化阅读体验，让韩漫网址成为中文世界里最值得信赖的韩国漫画阅读平台。
                    </p>
                  </div>
                </div>
                <div className="rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20warm%20and%20artistic%20illustration%20of%20people%20reading%20books%20together%20in%20a%20cozy%20modern%20library%20with%20large%20windows%20and%20natural%20light%2C%20soft%20warm%20tones%2C%20peaceful%20and%20inviting%20atmosphere%2C%20illustration%20style%20with%20gentle%20textures&width=800&height=600&seq=about-story-01&orientation=landscape"
                    alt="韩漫网址品牌故事 - 温暖的阅读空间"
                    title="韩漫网址 - 品牌故事"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                  我们的优势
                </h2>
                <p className="mt-2 text-sm text-foreground-600">
                  韩漫网址持续优化的核心能力
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {[
                  { icon: 'ri-translate-2', title: '专业中文翻译', desc: '与资深韩语翻译团队合作，确保译文准确流畅，忠实传达原作情感与细节。' },
                  { icon: 'ri-speed-up-line', title: '极速加载体验', desc: '优化的图片加载技术，即使在移动网络环境下也能流畅阅读，不卡顿不等待。' },
                  { icon: 'ri-device-line', title: '多设备适配', desc: '完美适配电脑、平板、手机等多种设备，随时随地享受下拉式阅读体验。' },
                  { icon: 'ri-calendar-check-line', title: '稳定更新频率', desc: '保持每日更新的稳定节奏，让读者不错过任何一部追更作品的精彩内容。' },
                ].map((item, i) => (
                  <div key={i} className="flex gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70">
                    <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className={`${item.icon} text-xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-base font-semibold text-foreground-900 mb-1 font-heading">{item.title}</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                  用户口碑
                </h2>
                <p className="mt-2 text-sm text-foreground-600">
                  来自读者的真实评价
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  {
                    name: '漫画迷小王',
                    role: '资深韩漫读者',
                    text: '终于找到一个不用付费就能看完整韩漫的网站了！翻译质量很高，下拉式阅读体验真的比翻页舒服太多了。现在已经把韩漫网址设成浏览器首页了。',
                    rating: 5,
                  },
                  {
                    name: '书虫小美',
                    role: '恋爱漫画爱好者',
                    text: '恋爱分类的漫画太全了！她秘密花园和心动信号都追完了，每一部都很好看。关键是全部无删减，原汁原味，比某些删改严重的平台好太多。',
                    rating: 5,
                  },
                  {
                    name: '夜读人阿杰',
                    role: '悬疑题材粉丝',
                    text: '第七个失踪者真的是我今年看过最好看的悬疑韩漫，一口气看到凌晨三点。韩漫网址的更新速度也很快，新章节上了马上就能看到。',
                    rating: 5,
                  },
                ].map((review, i) => (
                  <div key={i} className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                    <div className="flex gap-1 mb-4">
                      {Array.from({ length: review.rating }).map((_, j) => (
                        <i key={j} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-5">
                      &ldquo;{review.text}&rdquo;
                    </p>
                    <div className="flex items-center gap-3 border-t border-background-200/70 pt-4">
                      <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center text-secondary-700 text-sm font-bold">
                        {review.name.charAt(0)}
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                        <p className="text-xs text-foreground-500">{review.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                  联系我们
                </h2>
                <p className="mt-2 text-sm text-foreground-600">
                  有任何问题或建议？我们很乐意听取您的意见
                </p>
              </div>

              <form
                data-readdy-form
                className="space-y-4 bg-background-50 p-6 md:p-8 rounded-xl border border-background-200/70"
                action="https://readdy.ai/api/form/d9pc76gsenbniolessn0"
                method="POST"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const honeypot = formData.get('website_alt') as string;
                  if (honeypot && honeypot.trim() !== '') {
                    const msg = document.getElementById('contact-msg');
                    if (msg) { msg.textContent = '提交成功！我们会尽快回复您。'; msg.className = 'mt-4 text-sm text-green-600 text-center'; }
                    form.reset();
                    return;
                  }
                  formData.delete('website_alt');
                  try {
                    const res = await fetch(form.action, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                    });
                    const responseText = await res.text();
                    let parsed;
                    try { parsed = JSON.parse(responseText); } catch { parsed = null; }
                    const serverMsg = parsed?.meta?.message || parsed?.message || '';
                    const msg = document.getElementById('contact-msg');
                    if (res.ok && parsed?.code === 'OK') {
                      if (msg) { msg.textContent = '提交成功！我们会尽快回复您。'; msg.className = 'mt-4 text-sm text-green-600 text-center'; }
                      form.reset();
                    } else {
                      if (msg) { msg.textContent = serverMsg || '提交失败，请稍后再试。'; msg.className = 'mt-4 text-sm text-red-500 text-center'; }
                    }
                  } catch {
                    const msg = document.getElementById('contact-msg');
                    if (msg) { msg.textContent = '网络错误，请稍后再试。'; msg.className = 'mt-4 text-sm text-red-500 text-center'; }
                  }
                }}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      姓名 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="contact-name"
                      type="text"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="contact-email"
                      type="email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-800 mb-1.5">
                    主题
                  </label>
                  <input
                    id="contact-subject"
                    type="text"
                    name="subject"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                    placeholder="请输入主题"
                  />
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">
                    留言内容 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                    placeholder="请输入您的留言（最多500字）"
                  ></textarea>
                  <p className="mt-1 text-xs text-foreground-400">最多500个字符</p>
                </div>
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />
                <button
                  type="submit"
                  className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  发送留言
                </button>
                <p id="contact-msg" className="mt-4 text-sm text-center"></p>
              </form>

              <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
                <div className="text-center p-5">
                  <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <h4 className="text-sm font-medium text-foreground-900 mb-1 font-heading">电子邮箱</h4>
                  <p className="text-xs text-foreground-600">contact@hanman.example.com</p>
                </div>
                <div className="text-center p-5">
                  <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                    <i className="ri-customer-service-2-line text-xl"></i>
                  </div>
                  <h4 className="text-sm font-medium text-foreground-900 mb-1 font-heading">在线客服</h4>
                  <p className="text-xs text-foreground-600">工作日 9:00 - 18:00</p>
                </div>
                <div className="text-center p-5">
                  <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                    <i className="ri-question-answer-line text-xl"></i>
                  </div>
                  <h4 className="text-sm font-medium text-foreground-900 mb-1 font-heading">反馈建议</h4>
                  <p className="text-xs text-foreground-600">我们重视每一位读者的声音</p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}